__turbopack_context__.v({
  "alert_action": "Alert-module-scss-module__kNZ5Ua__alert_action",
  "alert_content": "Alert-module-scss-module__kNZ5Ua__alert_content",
  "alert_icon": "Alert-module-scss-module__kNZ5Ua__alert_icon",
  "alert_label": "Alert-module-scss-module__kNZ5Ua__alert_label",
  "alert_main": "Alert-module-scss-module__kNZ5Ua__alert_main",
  "alert_title": "Alert-module-scss-module__kNZ5Ua__alert_title",
  "alert_toolbar": "Alert-module-scss-module__kNZ5Ua__alert_toolbar",
});
